import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';

import Dashboard from './pages/Dashboard';
import CarPage from './pages/CarPage';
import AddCarPage from './pages/AddCarPage';
import AdminAgreementsPage from './pages/AdminAgreementsPage';
import RentCarPage from './pages/RentCarPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';

function PrivateRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) return <p>Loading...</p>;
  if (!user) return <Navigate to="/login" />;

  return children;
}

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/car/:carId"
          element={
            <PrivateRoute>
              <CarPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/add"
          element={
            <PrivateRoute>
              <AddCarPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/agreements"
          element={
            <PrivateRoute>
              <AdminAgreementsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/rent"
          element={
            <PrivateRoute>
              <RentCarPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}
